import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimpleResultSummaryComponent } from "./simple-result-summary.component";
import { TranslateModule } from "@ngx-translate/core";
import { ValgMessageBarModule } from '@valg-shared/components/valg-message-bar/valg-message-bar.module';
@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        ValgMessageBarModule
    ],
  declarations: [
    SimpleResultSummaryComponent
  ],
  exports: [
    SimpleResultSummaryComponent
  ]
})
export class SimpleResultSummaryModule {}
